var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-form",
    {
      attrs: { form: _vm.form },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "a-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("Görünen İsim") } },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.form.displayName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "displayName", $$v)
                      },
                      expression: "form.displayName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("İkon") } },
                [
                  _c("MaterialIconPicker", {
                    model: {
                      value: _vm.form.icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "icon", $$v)
                      },
                      expression: "form.icon",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("Açıklama") } },
        [
          _c("a-textarea", {
            attrs: { rows: 4 },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        [
          _c(
            "a-radio-group",
            {
              attrs: { "button-style": "solid" },
              model: {
                value: _vm.form.relation.type,
                callback: function ($$v) {
                  _vm.$set(_vm.form.relation, "type", $$v)
                },
                expression: "form.relation.type",
              },
            },
            [
              _c("a-radio-button", { attrs: { value: "table-to-table" } }, [
                _vm._v(_vm._s(_vm.$t("Tablo - Tablo"))),
              ]),
              _vm._v(" "),
              _c("a-radio-button", { attrs: { value: "table-to-standart" } }, [
                _vm._v(_vm._s(_vm.$t("Tablo - Standart"))),
              ]),
              _vm._v(" "),
              _c("a-radio-button", { attrs: { value: "standart-to-table" } }, [
                _vm._v(_vm._s(_vm.$t("Standart - Tablo"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.relation.type === "table-to-table"
        ? [
            _c(
              "a-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-card",
                      { attrs: { title: "Kaynak" } },
                      [
                        _c("TableConnectionForm", {
                          attrs: { tables: _vm.tables },
                          model: {
                            value: _vm.form.relation.tableToTable.from,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.relation.tableToTable,
                                "from",
                                $$v
                              )
                            },
                            expression: "form.relation.tableToTable.from",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-card",
                      { attrs: { title: "Hedef" } },
                      [
                        _c("TableConnectionForm", {
                          attrs: { tables: _vm.tables },
                          model: {
                            value: _vm.form.relation.tableToTable.to,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.relation.tableToTable,
                                "to",
                                $$v
                              )
                            },
                            expression: "form.relation.tableToTable.to",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.form.relation.type === "table-to-standart"
        ? [
            _c(
              "a-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-card",
                      { attrs: { title: "Kaynak" } },
                      [
                        _c("TableConnectionForm", {
                          attrs: { tables: _vm.tables },
                          model: {
                            value: _vm.form.relation.tableToStandart.from,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.relation.tableToStandart,
                                "from",
                                $$v
                              )
                            },
                            expression: "form.relation.tableToStandart.from",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-card",
                      { attrs: { title: "Hedef" } },
                      [
                        _c("StandartModuleConnectionForm", {
                          attrs: {
                            "contact-properties": _vm.contactProperties,
                          },
                          model: {
                            value: _vm.form.relation.tableToStandart.to,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.relation.tableToStandart,
                                "to",
                                $$v
                              )
                            },
                            expression: "form.relation.tableToStandart.to",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.form.relation.type === "standart-to-table"
        ? [
            _c(
              "a-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-card",
                      { attrs: { title: "Kaynak" } },
                      [
                        _c("StandartModuleConnectionForm", {
                          attrs: {
                            "contact-properties": _vm.contactProperties,
                          },
                          model: {
                            value: _vm.form.relation.standartToTable.from,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.relation.standartToTable,
                                "from",
                                $$v
                              )
                            },
                            expression: "form.relation.standartToTable.from",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-card",
                      { attrs: { title: "Hedef" } },
                      [
                        _c("TableConnectionForm", {
                          attrs: { tables: _vm.tables },
                          model: {
                            value: _vm.form.relation.standartToTable.to,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.relation.standartToTable,
                                "to",
                                $$v
                              )
                            },
                            expression: "form.relation.standartToTable.to",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }